const supportHighlights = [
  { label: 'Open tickets', value: '7', meta: 'Assigned to Help hub' },
  { label: 'Live chats', value: '3', meta: 'Connected right now' },
  { label: 'Avg. response', value: '2m', meta: 'From Carewinners admins' },
];

const contactOptions = [
  { title: 'Schedule a call', desc: 'Book a quick check-in with the support team' },
  { title: 'Live chat', desc: 'Respond to a user in the Carewinners console' },
  { title: 'Submit a ticket', desc: 'Create a support ticket for follow up' },
];

function SupportPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-3">
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Support</p>
        <h1 className="text-3xl font-semibold text-slate-900">Help hub</h1>
        <p className="text-slate-600">
          Welcome to the support cockpit. Switch between live conversations, tickets, and scheduled calls anytime.
        </p>
      </header>
      <section className="grid gap-4 md:grid-cols-3">
        {supportHighlights.map((item) => (
          <article
            key={item.label}
            className="rounded-3xl border border-emerald-100 bg-white px-5 py-6 shadow-sm shadow-slate-200"
          >
            <p className="text-xs uppercase tracking-[0.4em] text-emerald-500">{item.label}</p>
            <p className="mt-3 text-3xl font-semibold text-slate-900">{item.value}</p>
            <p className="text-sm text-slate-500">{item.meta}</p>
          </article>
        ))}
      </section>
      <section className="grid gap-4 md:grid-cols-3">
        {contactOptions.map((option) => (
          <article
            key={option.title}
            className="rounded-3xl border border-emerald-100 bg-emerald-50/70 px-4 py-5 shadow-lg shadow-emerald-100"
          >
            <p className="text-sm font-semibold text-slate-900">{option.title}</p>
            <p className="mt-2 text-xs text-slate-600">{option.desc}</p>
          </article>
        ))}
      </section>
    </div>
  );
}

export default SupportPage;
